#import "./automation-conditions-fragment.graphql"

fragment StageSlackMessageData on Stage {
    editableSlackMessageAutomations {
        id
        channelId
        conditions {
            ...Condition
        }
        slackChannel {
            display
            externalId
            name
        }
    }
}
